import { render, staticRenderFns } from "./GradeAssignmentModal.vue?vue&type=template&id=ecc9b4b6&scoped=true&"
import script from "./GradeAssignmentModal.vue?vue&type=script&lang=js&"
export * from "./GradeAssignmentModal.vue?vue&type=script&lang=js&"
import style0 from "./GradeAssignmentModal.vue?vue&type=style&index=0&id=ecc9b4b6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ecc9b4b6",
  null
  
)

export default component.exports